/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

export * from "./SlimContactCards.section";
